import { render, staticRenderFns } from "./QuestionsSection.vue?vue&type=template&id=105d64f6&scoped=true"
import script from "./QuestionsSection.vue?vue&type=script&lang=js"
export * from "./QuestionsSection.vue?vue&type=script&lang=js"
import style0 from "./QuestionsSection.vue?vue&type=style&index=0&id=105d64f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105d64f6",
  null
  
)

export default component.exports